import { render } from "./Price.vue?vue&type=template&id=6ac1424e"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/otc/Price.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ac1424e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ac1424e', __exports__)) {
    api.reload('6ac1424e', __exports__)
  }
  
  module.hot.accept("./Price.vue?vue&type=template&id=6ac1424e", () => {
    api.rerender('6ac1424e', render)
  })

}


export default __exports__